module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00143.495bd060.jpg";